// export const server = `https://mpstaging.iauto.sg/api/cms/`; // staging
export const server = `https://manage.iauto.sg/api/cms/`; // production

export const requestAuthOption = (formData) => {
    let token = JSON.parse(localStorage.getItem("token"))

    if (formData) {
        const requestOptions = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`, // ✅ keep the token
                // ❌ don't set 'Content-Type' here
            },
            body: formData,
        };
        return requestOptions
    }
}
